import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import PlayableAudioCard from '../PlayableAudioCard';
import styles from './PlayableAudioCardList.module.scss';

const PlayableAudioCardList = ({
    header,
    items = [],
    row = false,
    selectedProductId = null,
    defaultAccordionSortOrder = null,
    containImages = false,
    isHighlight = false,
    triggerProductChooserOnDownload = false,
    hasTags,
    productSelectionOptions,
    selectedProductLatestSoundVersionNumber,
}) => {
    const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
    if (items.length < 1) {
        return null;
    }

    const stopCurrentlyPlaying = () => {
        if (currentlyPlaying) {
            currentlyPlaying.pause();
        }
    };

    return (
        <div className={styles['PlayableAudioCardList']}>
            {header && (
                <h3 className={styles['PlayableAudioCardList__Header']}>
                    {header}
                </h3>
            )}
            <div
                className={classNames({
                    [styles['PlayableAudioCardList__List']]: !row,
                    [styles['PlayableAudioCardList__List--Row']]: row,
                })}>
                {items.map((item, i) => (
                    <div
                        key={item.id}
                        className={styles['PlayableAudioCardList__Item']}>
                        <PlayableAudioCard
                            {...item}
                            key={item.id}
                            id={item.id}
                            hasTags={hasTags}
                            disableHoverEffect={!!item.accordionItems}
                            row={row}
                            isHighlight={isHighlight}
                            triggerProductChooserOnDownload={
                                triggerProductChooserOnDownload
                            }
                            defaultAccordionSortOrder={
                                defaultAccordionSortOrder
                            }
                            selectedProductId={selectedProductId}
                            forceContainImage={containImages}
                            onPlay={(player) => {
                                if (currentlyPlaying !== player) {
                                    stopCurrentlyPlaying();
                                    setCurrentlyPlaying(player);
                                }
                            }}
                            onPause={() => {
                                stopCurrentlyPlaying();
                                setCurrentlyPlaying(null);
                            }}
                            productSelectionOptions={productSelectionOptions}
                            selectedProductLatestSoundVersionNumber={
                                selectedProductLatestSoundVersionNumber
                            }
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

PlayableAudioCardList.propTypes = {
    items: PropTypes.array,
    row: PropTypes.bool,
    isHighlight: PropTypes.bool,
    containImages: PropTypes.bool,
};

export default PlayableAudioCardList;
